import React, { useEffect, useState } from 'react';

import Logo from 'assets/images/logo.svg';

import {
  IConsultantCompany,
  IConsultantDetails,
  IConsultantResponse,
  IUser,
} from 'types/interfaces/sulu/IUser';

import getConsultant from 'utils/sulu/getConsultant';

import getAllConsultants from '../../../utils/sulu/getAllConsultants';

export interface IConsultantTileSmall {
  id: number;
  name: string;
  url: string;
}

const ConsultantTileSmall = ({ id, name, url }: IConsultantTileSmall) => {
  const [hover, setHover] = useState<boolean>(false);
  const [consultantProfile, setConsultantProfile] = useState<IUser | null>(
    null,
  );
  const [company, setCompany] = useState<IConsultantCompany | undefined>(
    undefined,
  );
  const [avatar, setAvatar] = useState<string | null>(null);

  useEffect(() => {
    getConsultant(id).then(profile => {
      setConsultantProfile(profile);
    });
  }, [id]);

  useEffect(() => {
    const cDetails: IConsultantDetails | undefined = consultantProfile
      ? consultantProfile.consultantDetails
      : undefined;
    setCompany(cDetails ? cDetails.company : undefined);
  }, [consultantProfile, company]);

  useEffect(() => {
    getAllConsultants().then((consultants: IConsultantResponse[]) => {
      const foundConsultant = consultants?.find(
        consultant => consultant.id === id,
      );
      if (foundConsultant) {
        const updatedAvatar = foundConsultant.avatar.replace(
          '/1200x627/',
          '/sulu-400x400/',
        );
        setAvatar(updatedAvatar);
      }
    });
  }, [id]);

  const bgImageStyle = {
    backgroundImage: avatar ? `url(${avatar})` : '',
  };

  const focalPointsList = (focalPoints: string[] | undefined) => {
    if (!focalPoints) return null;

    const subcategories = focalPoints.map(
      focalPoint => focalPoint.split('_')[1],
    );

    return (
      <div>
        <p>{subcategories.join('; ')}</p>
      </div>
    );
  };

  return (
    <a
      className='gap-4 rounded-xl border-2 hover:text-inherit overflow-hidden'
      href={url}
    >
      <div
        className='w-52 p-2.5 rounded-xl cursor-pointer overflow-hidden bg-blue-light'
        onMouseOver={() => setHover(true)}
        onFocus={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onBlur={() => setHover(false)}
        role='button'
        tabIndex={0}
      >
        <div className='relative pt-[100%] rounded-md shadow-md'>
          {bgImageStyle.backgroundImage ? (
            <div
              className={`absolute inset-0 rounded-md bg-center bg-no-repeat bg-cover transition-all
    ${hover ? 'brightness-50' : 'brightness-100'}`}
              style={bgImageStyle}
            />
          ) : (
            <div
              className={`absolute inset-0 rounded-md bg-center bg-no-repeat bg-cover bg-gradient-to-t from-[#B5B5B5] to-[#E4E3E5] transition-all
    ${hover ? 'brightness-50' : 'brightness-100'}`}
            >
              <Logo className='w-[75%] h-[50%] mt-12 mx-auto fill-white' />
            </div>
          )}

          <div
            className={`flex text-black bg-white/90 px-2.5 py-0.5 rounded-full absolute top-2 left-2 transition-opacity ${
              hover ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <span className='text-xs'>
              {consultantProfile?.consultantDetails?.categories[0]}
            </span>
          </div>
        </div>

        <div className='relative flex items-center h-12 px-2 mt-2'>
          <p
            className={`absolute left-2 right-2 inset-y-0 font-bold line-clamp-2 transition-all ${
              hover ? 'text-white' : ''
            }`}
            style={{
              transform: hover ? 'translateY(calc(-100% - 1rem))' : '',
            }}
          >
            {name}
          </p>
          <p
            className={`text-black text-sm line-clamp-2 transition-opacity ${
              hover ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {focalPointsList(consultantProfile?.consultantDetails?.focalPoints)}
          </p>
        </div>
      </div>
    </a>
  );
};

export default ConsultantTileSmall;
